/**
 * 此檔案用於定義應用程式的常數和配置。
 * 這些常數用於應用程式的不同部分，以確保一致性和可讀性。
 *
 * 使用規則或限制：
 * 1.常數的命名規則遵循小寫駝峰式命名法。
 * 2.引入檔案需要寫絕對位置且指定資料夾，避免相對位置 by Allen
 */
import icon_suspension from '@icoach/assets/img/icon_doc_suspension.png';
import icon_termination from '@icoach/assets/img/icon_doc_termination.png';

import { APPOINTMENT_TYPE, MEMBERSHIP_STATUS, MEMBERSHIP_CONTRACT_VERSION,PEOPLE_SOURCE_TYPE, MEMBER_SITE_LOGON_TYPE } from "@icoach/constants/dataEnums";

export const AllFaType = [APPOINTMENT_TYPE.FA, APPOINTMENT_TYPE.INVALIDMEMBERFA];

/**
 * 顧客預約->親友名單使用
 * 自店社群(2)、既有名單(4)、自店BR(8)、BR名單(11)、CP去電(13)、GP名單(14) 皆帶入一樣 否則 都是自店BR(8)
 */
export const FRIEND_ORIGIN_RULE= [
    PEOPLE_SOURCE_TYPE.SELFCLUBSOCIAL,
    PEOPLE_SOURCE_TYPE.EXISTINGLIST,
    PEOPLE_SOURCE_TYPE.SELFCLUBBR,
    PEOPLE_SOURCE_TYPE.CPCALLOUT,
    PEOPLE_SOURCE_TYPE.GPLIST
];

// 勵馨基金會 愛心碼
export const DEFAULT_LOVE_CODE_LICHING_FOUNDATION = 9118595;

// 智能系統會員須知
export const FITNESSBANDAGREEMENTTEXT = {
    101: 
    [
        {
            img  : icon_suspension,
            title: '訂閱系統暫停',
            items: [
                '智能訂閱服務系統之暫停月份，將如同會員會籍之暫停月份辦理，並同步辦理相關作業。',
                '會員於訂閱服務期間，如需暫停使用本服務，應「月為單位」提出申請，本人親自赴所屬店舖辦理暫停',
                '為配合銀行作業，會員須於暫停前最近一次扣款日之前十日辦理',
            ]
        },
        {
            img  : icon_termination,
            title: '會員權終止',
            items: [
                '會員於退訂月份15號(含)前提出申請，可使用系統至當月15日，並退還該月份系統使用費半數。若於退訂月份15號後提出，則可使用系統至月底。',
                '會員提出退訂申請後，系統應於24小時內通知信用卡發卡銀行終止扣款作業',
                '會員退訂後，其於本系統服務期間之運動及健康數據資料，系統將保留一個月',
                '會員若終止本訂閱服務，並欲重新訂閱，將視為新契約關係，適用所有初次簽約之費用與條件，包括開通設定費。原契約與新契約視為各自獨立契約，先前支付之費不予轉移或抵扣。',
            ]
        }
    ]
}

export const VALID_MEMBERSHIP_STATUSES = [MEMBERSHIP_STATUS.NORMAL, MEMBERSHIP_STATUS.SUSPEND]

export const MEMBERSHIP_TRANSFER_IN_FORM_CONTRACT_VERSION_QUIT_FEE_TIP = {
    [MEMBERSHIP_CONTRACT_VERSION.MEMBERSHIP2017]  : `按比例退還入會費，終止手續費最高不超過3600`,
    [MEMBERSHIP_CONTRACT_VERSION.MEMBERSHIP2022]  : `月平均差額計算方式，終止手續費最高不超過3600`,
    [MEMBERSHIP_CONTRACT_VERSION.Membership202310]: `月平均差額計算方式，終止手續費最高不超過3600`,
    [MEMBERSHIP_CONTRACT_VERSION.Membership202501]: `因應個資專案調整會員規章內容（退會計算方式同 2022.01），終止手續費最高不超過3600`,
    [MEMBERSHIP_CONTRACT_VERSION.Membership202510]: `月平均差額計算方式，終止手續費最高不超過3800`,
    [MEMBERSHIP_CONTRACT_VERSION.Membership202610]: `月平均差額計算方式，終止手續費最高不超過3800`,
}

/**
 * 測試開發專區使用
 */
export const devRegexList = [/^localhost$/, /^icoach-dev/, /^192\.168\.0\./,/^curvesuat-dev-a/];

/**
 * PDF.js worker 的 CDN 位址（PdfComponent、UploadBox 共用，避免各自寫死造成版本不一致）
 * 版本須與 pdfjs-dist 套件版本精確相符
 */
export const PDFJS_WORKER_URL = "https://s.curves.com.tw/common/Scripts/pdf.worker.min.js";

/**
 * 日期專用
 */
export const DATE_TIME_STANDARD = {
    DISPLAYTPFULL          : 'YYYY-MM-DDTHH:mm:ss',
    DISPLAYFULL            : 'YYYY-MM-DD HH:mm',
    DISPLAYYEARMONTH       : 'YYYY-MM',
    DISPLAYDATE            : 'YYYY-MM-DD',
    DISPLAYFULLBYSLASH     : 'YYYY/MM/DD HH:mm',
    DISPLAYDATEBYSLASH     : 'YYYY/MM/DD',
    DISPLAYDATEOFWEEK      : 'YYYY/MM/DD(dd)',
    DISPLAYDATEOFMONTH     : 'YYYY/MM',
    DISPLAYTIME            : 'HH:mm',
    DISPLAYDATEWITHOUTMINUS: 'YYYYMMDD',
};

/**
 * POS開關
 */
export const IS_SHOW_POS = ["DEV","UAT"];

/**
 * 健康指引
 */
export const IS_SHOW_SPORT_ADVISE = ["DEV","UAT"]

export const MEMBER_SITE_LOGON_TYPE_DESCRIPTION = {
    [MEMBER_SITE_LOGON_TYPE.MEMBER]  : '會員',
    [MEMBER_SITE_LOGON_TYPE.EMPLOYEE]: '教練',
}

/**
 * 顧客管理 對應front key
 */
export const NONMEMBER_TABS = {
    CUSTOMER    : "CUSTOMER_VALUE",
    PROSPECT    : "PROSPECT_VALUE",
    TEMPORARIES : "TEMPORARIES_VALUE",
    ADD_CUSTOMER: "ADD_CUSTOMER",
    ADD_PROSPECT: "ADD_PROSPECT",
}
